import { isNextStyleEnabled, customTokens } from "@1js/acui-theme";
import type { IButtonStyles } from "@fluentui/react";
import { mergeStyleSets } from "@fluentui/react";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import { PaddleOrientation } from "./AppPaddleButton.Props";

export const appPaddleWidth = 24;

/**
 * Styles for an AppPaddleButton
 * @param orientation If the paddle is on the left or right side
 * @param disableModeTogglePadding If the application has not enabled the mlr mode toggle padding reserve
 */
export const getPaddleButtonStyles = memoizeFunction(
  (
    orientation: PaddleOrientation,
    isRTL: boolean,
    disableModeTogglePadding?: boolean
  ): IButtonStyles => {
    return mergeStyleSets(
      {
        root: [
          {
            position: "absolute",
            padding: 0,
            height: "100%",
            width: appPaddleWidth,
            borderRadius: 0,
          },
          orientation === PaddleOrientation.Left && {
            left: 0,
          },
          orientation === PaddleOrientation.Right && {
            right: disableModeTogglePadding ? 0 : 20,
          },
        ],
        icon: {
          height: 12,
          width: 12,
          transform:
            (orientation === PaddleOrientation.Left && !isRTL) ||
            (isRTL && orientation === PaddleOrientation.Right)
              ? "rotate(90deg)"
              : "rotate(270deg)",
          lineHeight: 12,
        },
      },
      isNextStyleEnabled() &&
        getPaddleStylesNext(orientation, disableModeTogglePadding)
    );
  }
);

const getPaddleStylesNext = memoizeFunction(
  (
    orientation: PaddleOrientation,
    disableModeTogglePadding?: boolean
  ): Partial<IButtonStyles> => {
    return {
      root: [
        {
          backgroundColor: customTokens.colorNeutralBackground1,
          border: `1px solid ${customTokens.colorNeutralStroke1}`,
        },
        orientation === PaddleOrientation.Right && {
          right: disableModeTogglePadding ? 0 : 28,
        },
      ],
      rootHovered: {
        backgroundColor: customTokens.colorNeutralBackground1Hover,
        border: `1px solid ${customTokens.colorNeutralStroke1Hover}`,
      },
      rootPressed: {
        backgroundColor: customTokens.colorNeutralBackground1Pressed,
        border: `1px solid ${customTokens.colorNeutralStroke1Pressed}`,
      },
    };
  }
);
